import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { StatusFilter, UserTypeCombo, RoleCombo } from 'areas/shared/controls'
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'

class Search extends SetupSearch {
    initialForm() {
        return {
            searchText: "",
            statusFilter: true,
            roleId: null,
            userTypeCode: null
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    userTypeCodeChange = (value) => {
        this.setState({
            userTypeCode: value,
            roleId: null
        });
        this._roleCombo.refresh();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'user'
            }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={3}>
                    <SearchBox
                        name="searchText"
                        label="searchText"
                        placeholder="Search users..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={2}>
                    <UserTypeCombo name="userTypeCode" clearable onChange={this.userTypeCodeChange} />
                </Col>
                <Col md={2}>
                    <RoleCombo 
                        name="roleId" 
                        placeholder="Select..." 
                        userTypeCode ={this.state.form.userTypeCode}
                        disabled={!this.state.form.userTypeCode} 
                        onChange={this.search} 
                        clearable 
                        ref={(c) => { this._roleCombo = c }} />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="users" />
                </Col>
            </Row>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/userSetup/Search.js